// extracted by mini-css-extract-plugin
export var divider = "_m7-0";
export var systemMessage = "_m7-1";